class ShotInPalette extends HTMLElement {
  constructor() {
    super();
    $(document).ready(() => {
      this.initialize();
    })
  }

  initialize() {
    this.items = document.querySelectorAll('[hover-item]');
    this.items.forEach((item, index) => {
      item.addEventListener('mouseenter', () => {
        this.hideItems(index);
      }, { passive: true })
      item.addEventListener('mouseleave', () => {
        this.showItems();
      }, { passive: true })
    })
  }

  hideItems(activeIndex) {
    this.items.forEach((item, index) => {
      if(index == activeIndex) return;

      gsap.to(item.querySelector('.no-blend'), {
        opacity: 0,
        duration: 0.7,
        ease: 'Power4.out'
      });
    }) 
  }

  showItems() {
    this.items.forEach(item => {
      gsap.to(item.querySelector('.no-blend'), {
        opacity: 1,
        duration: 0.7,
        ease: 'Power4.out'
      });
    }) 
  }
}

customElements.define('shot-in-palette', ShotInPalette);
